// export default function ElementLayoutCard({ layout, index }) {

//   // console.log("layout card rendered:"+layout.type);
//   return (
//     <div
//       key={index}
//       className="flex flex-col items-center justify-center border-2 backdrop-blur-sm border-gray-300 rounded-xl p-2 group hover:shadow-lg hover:border-blue-300 hover:scale-105 cursor-pointer bg-white transition-all duration-200"
//     >
//       <layout.icon className="p-1 h-8 w-8 bg-gradient-to-br from-purple-50 to-pink-50 group-hover:from-blue-100 group-hover:to-orange-100 rounded-xl transition-all duration-200" />
//       <h2 className="text-sm font-medium text-gray-700 mt-2 transition-colors duration-200">
//         {layout.label}
//       </h2>
//     </div>
//   );

//   // return (
//   //   <div
//   //     key={index}
//   //     className="flex flex-col items-center justify-center border border-dashed rounded-xl p-3 group hover:shadow-md hover:border-primary cursor-pointer bg-white"
//   //   >
//   //     {
//   //       <layout.icon className="p-2 h-9 w-9 bg-gray-100 group-hover:text-primary group-hover:bg-purple-100 rounded-full" />
//   //     }
//   //     <h2 className="text-sm group-hover:text-primary">{layout.label}</h2>
//   //   </div>
//   // );
// }

export default function ElementLayoutCard({ layout, index }) {
  return (
    <div
      key={index}
      className="flex items-center gap-2 border border-gray-200 rounded-lg p-2 group hover:shadow-md hover:border-indigo-300 hover:bg-indigo-50/30 cursor-grab active:cursor-grabbing bg-white transition-all duration-200"
    >
      <div className="flex-shrink-0 p-1.5 bg-gradient-to-br from-indigo-50 to-blue-50 group-hover:from-indigo-100 group-hover:to-purple-100 rounded-md transition-all duration-200">
        <layout.icon className="h-4 w-4 text-indigo-600 group-hover:text-indigo-700" />
      </div>
      <h2 className="text-xs font-medium text-gray-700 group-hover:text-indigo-700 transition-colors duration-200">
        {layout.label}
      </h2>
    </div>
  );
}
